import React, { FC } from "react";
import { IconProps } from "@shared/ui/Icon/ui/types";

export const DeleteIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        width={20}
        height={20}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 20 20"
    >
        <path
            fill="currentColor"
            d="M13.5224 2.2165a.7122.7122 0 0 1-.5037.2087H7.272a.7123.7123 0 0 1-.7124-.7124.6888.6888 0 0 1 .7124-.7124h5.7467a.6857.6857 0 0 1 .2765.0475.6877.6877 0 0 1 .3884.3884.6895.6895 0 0 1 .0475.2765.7123.7123 0 0 1-.2087.5037ZM8.981 14.6299a.736.736 0 0 1-.4971.2152.7124.7124 0 0 1-.7125-.7124V9.0272a.689.689 0 0 1 .436-.665.6875.6875 0 0 1 .2765-.0474.7124.7124 0 0 1 .7123.7124v5.1055a.7362.7362 0 0 1-.2152.4972ZM11.8075 14.8451a.7123.7123 0 0 0 .7124-.7124V9.0272a.685.685 0 0 0-.1111-.3998.688.688 0 0 0-.6013-.3126.7124.7124 0 0 0-.7124.7124v5.1055a.7358.7358 0 0 0 .7124.7124Z"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M2.7128 4.1347h14.8654a.6876.6876 0 0 1 .5111.2013.6881.6881 0 0 1 .2013.511.7123.7123 0 0 1-.7124.7125h-1.0686v11.3033A2.1373 2.1373 0 0 1 14.3724 19H5.9186a2.1374 2.1374 0 0 1-2.1372-2.1372V5.5595H2.7128a.7123.7123 0 0 1-.7124-.7125.6882.6882 0 0 1 .2013-.511.6878.6878 0 0 1 .5111-.2013Zm12.3245 13.0046a.6892.6892 0 0 0 .0475-.2765V5.5595H5.2062v11.3033a.6885.6885 0 0 0 .7124.7124h8.4538a.6877.6877 0 0 0 .5111-.2013.6862.6862 0 0 0 .1538-.2346Z"
            clipRule="evenodd"
        />
    </svg>
);